import { IRoute } from '../types/route';
import privateRoutes from './private';
import protectedRoutes from './protected';
import publicRoutes from './public';

type Routes = {
  public: IRoute[];
  private: IRoute[];
  protected: IRoute[];
};

export const routes: Routes = {
  public: publicRoutes,
  private: privateRoutes,
  protected: protectedRoutes,
};
